/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItem_item = {
    readonly serviceId: string | null;
    readonly isFurniture: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"ItemTile_item">;
    readonly " $refType": "PdpRespSimilarItem_item";
};
export type PdpRespSimilarItem_item$data = PdpRespSimilarItem_item;
export type PdpRespSimilarItem_item$key = {
    readonly " $data"?: PdpRespSimilarItem_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItem_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": null
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isFurniture",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ItemTile_item",
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        }
      ]
    }
  ]
};
(node as any).hash = '43420e536c07ec1a625973f58c3d4206';
export default node;
